module.exports = __webpack_public_path__ + "media/images/lb/543-73c64e42c0e8b82e7b5a043fe4e6aacb.svg";